export const addBracketsMixin = {
    methods: {
        addBrackets: (str) => (str ? `[${str}]` : ""),
    },
};
